import React, { Component } from "react";
import { Link } from "react-router-dom";

import Header from "../layout/header";
import Footer4 from "../layout/footer4";
import ClientSlider1 from "../element/clientSlider1";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import ScrollToTop from "../element/scrollToTop";
import jsonData from "../JasonData/Lfc.json";
import jsonData2 from "../JasonData/Lfc2.json";
import jsonData3 from "../JasonData/Lfc3.json";

var bnr3 = require("./../../images/banner/bnr3.webp");

class Lfc extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  constructor(props) {
    super(props);
    this.state = {
      isPopupOpen: false,
      name: "",
      email: "",
      mobile: "",
      showSuccessMessage: false,
      alertMessage: "", // New state for alert message content
      alertType: "", // New state for alert type (success or error)
      captchaToken: "", // New state for captcha token
    };
  }

  openPopup = () => {
    this.setState({ isPopupOpen: true });
  };

  closePopup = () => {
    this.setState({ isPopupOpen: false, alertMessage: "", alertType: "" });
  };
  // Handle captcha change
  handleRecaptchaChange = (token) => {
    this.setState({ captchaToken: token });
  };

      handleDownload = () => {
    const urls = [
      "/pdf/Castomech Catalogue 1.pdf",
      "/pdf/Castomech Catalogue 2.pdf"
    ];
    urls.forEach((url, i) => {
      const link = document.createElement("a");
      link.href = process.env.PUBLIC_URL + url;
      link.download = 'Castomech Catalogue ' + (i + 1) + '.pdf';
      link.style.display = "none";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
      }, i * 500);
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleFormSubmit = (e) => {
    e.preventDefault();
    const { name, email, mobile } = this.state;
    const templateParams = { name, email, mobile, phone: mobile };

    emailjs
      .send(
        "service_28emj8y",
        "template_2rotnxq",
        templateParams,
        "IDZukK49bAWi8Pkt0"
      )
      .then(() => {
        this.setState({
          showSuccessMessage: true,
          alertMessage: "Details submitted successfully! Thank you.",
          alertType: "success",
        });
        this.handleDownload();
        setTimeout(() => this.closePopup(), 3000); // Optional: Close popup after 3 seconds
      })
      .catch((error) => {
        console.error("Failed to send email:", error);
        this.setState({
          alertMessage: "Failed to submit details. Please try again.",
          alertType: "error",
        });
      });
  };

  render() {
    const {
      isPopupOpen,
      name,
      email,
      mobile,
      alertMessage,
      alertType,
      captchaToken,
    } = this.state;
    return (
      <>
        <Header />
        
        {/* --- SIMPLE & CLEAN MINI BANNER --- */}
        <div 
          className="dlab-bnr-inr overlay-black-middle text-center"
          style={{ 
            height: "45vh", 
            minHeight: "350px", 
            backgroundImage: "url(" + bnr3 + ")",
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            textAlign: "center"
          }}
        >
          <div className="container" style={{ zIndex: 5, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <div style={{ animation: "fadeUp 1s ease-out", width: "100%" }}>
              <span style={{ color: "#ff4b2b", fontSize: "14px", fontWeight: "700", textTransform: "uppercase", letterSpacing: "3px", display: "block", marginBottom: "15px" }}>Advanced Casting Processes</span>
              <h1 style={{ color: "white", fontSize: "3.5rem", fontWeight: "800", marginBottom: "20px", textShadow: "0 4px 15px rgba(0,0,0,0.4)" }}>
                Lost Foam Casting Process
              </h1>
              <div style={{ width: "60px", height: "4px", background: "#ff4b2b", margin: "0 auto", borderRadius: "2px" }}></div>
            </div>
          </div>
          
          {/* Subtle curved divider */}
          <div style={{ position: "absolute", bottom: "-1px", left: 0, width: "100%", overflow: "hidden", lineHeight: 0 }}>
            <svg viewBox="0 0 1200 120" preserveAspectRatio="none" style={{ position: "relative", display: "block", width: "calc(100% + 1.3px)", height: "40px" }}>
              <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5,73.84-4.36,147.54,16.88,218.2,35.26,69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113,14.29,1200,52.47V0Z" fill="#ffffff" opacity=".25"></path>
              <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" fill="#ffffff" opacity=".5"></path>
              <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.41,78.3,34.2,160.25,37.78,242.09,13.67,61.8-18.2,123.47-52.61,188.91-58.8V0Z" fill="#ffffff"></path>
            </svg>
          </div>
        </div>

        <style dangerouslySetInnerHTML={{__html: `
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}} />

        <br />
        <div className="page-content bg-white">
          <div className="content-block">
            <div className="container">
              <div className="section-full content-inner bg-white video-section">
                <div className="container">
                  <div className="section-content">
                    <div className="row d-flex">
                      <div className="col-lg-12 col-md-12 m-b30 ">
                        <div className="content-bx1">
                          <label
                            className="gradiant-label"
                            style={{ color: "white", fontSize: "x-large" }}
                          >
                            Lost Foam{" "}
                            <span style={{ color: "#ee4c21" }}>
                              Casting process
                            </span>
                          </label>

                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            Introduction of LFC Process  Lost Foam Casting
                            process (LFC) is the process that uses foamed
                            polymer models to replace the casting and parts of
                            the gating system. Because the polymer models are
                            destroyed during this process.
                          </p>

                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            Within Lost Foam Casting process, the models are
                            typically made of foamed expandable poly- styrene
                            (EPS), of foamed expandable polymithyle methacrylate
                            (PMMA) or of a foamed co-polymer of EPS, PMMA &
                            STMMA. The models are created in permanent molds on
                            automatic foaming machines, with a predefined
                            thickness. By gluing simple models together, model
                            segments are then com- binned to complex models.
                            After that, several models are often combined to
                            model trees. After atteaching the gating system, the
                            model is coated by a fire resistant, inorganic
                            coating and embedded into compressed sand that is
                            free from binding agents.
                          </p>
                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            Within the actual casting process, the metal melt
                            replaces the polymer model. The foam is being
                            pyrolized by the high melt temperatures (exchanged
                            mainly by accompanying radiation), and the liquid
                            metal fills the resulting cavity.
                          </p>
                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            A couple of decomposition products, like CO2, CO and
                            several organic compounds, are created by the
                            pyrolysis reaction. Depending on the melt
                            temperature, these are either mostly liquid or
                            mostly gaseous products. If aluminum alloys are
                            casted with Lost Foam Casting, there are more liquid
                            pyrolysis products (due to the lower melt
                            temperatures) than in the case of iron or steel
                            castings, where the pyrolysis reaction produces
                            mainly gases.
                          </p>
                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            The emission of the pyrolysis products usually
                            penetrates through the coating into the sand mold.
                            The coating consequently plays a vital role in
                            controlling the filling pattern of mold filling,
                            apart from the tasks of enhancing the casting's
                            surface quality and stabilizing the sand mold.
                          </p>
                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            Liquid decomposition products, which are created
                            during Lost Foam process of aluminum casting,
                            are absorbed by the coating in a first decomposition
                            phase (primary pyrolysis). In a second decomposition
                            phase (secondary pyrolysis), the liquid products are
                            further decomposed into gas. These are then absorbed
                            by the surrounding mold material.
                          </p>
                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            On the other hand, during  Lost Foam casting of
                            iron and steel, the gaseous decomposition products
                            immediately develop due to the higher melt
                            temperatures. The pyrolysis gases form a gap between
                            the melt surface and those parts of the foam model
                            that has not yet collapsed. There-upon the gases
                            also pass through the coating into the surrounding
                            mold material, where they finally condense. While
                            the mold sand heats up more and more, a secondary
                            pyrolysis starts here, too.
                          </p>
                          <p className="m-b30">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            Obviously, a certain porosity and gas permeability
                            of the coating is vital for the application in the
                            Lost Foam Casting process. Unsatisfactory gas
                            permeability results in the formation of gas
                            entrapments and porosities. An unsatisfactory
                            absorption of liquid products leads to wrinkles,
                            cold shuts and entrapment errors, if the liquid
                            polymers remain in front of the metal front.
                            Moreover, the liquid products do not penetrate deep
                            into the mold material; due to their high viscosity,
                            they concentrate on the surface. This can lead to a
                            "closing" of the pores, so that the venting is no
                            longer guaranteed.
                          </p>
                          <p className="m-b0">
                            <i
                              className="fa fa-gear "
                              style={{
                                fontSize: "18px",
                                fontWeight: "500",
                                marginRight: "10px",
                              }}
                            ></i>
                            During the compaction of the mold sand, one must
                            ensure a compaction of the mold material as even as
                            possible in order to avoid the corresponding casting
                            errors. An even compaction is a pre- requisite for a
                            reproducible venting of the cavity during mold
                            filling. Undercuts that appear during the embedding
                            of the foam tree into the sand bed and a resulting
                            uneven compaction must possibly be avoided. The mold
                            material's compaction is achieved by unit- order
                            multiaxial vibration pro- cases with a corresponding
                            variation of the chosen frequencies.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />
            <br />
            <br />
          </div>
        </div>
        <div className="page-content" style={{ background: "#f4f4f4", padding: "40px 0" }}>
  {/* Main Title */}
  <div className="container text-center mb-5">
    <label
      className="gradiant-label"
      style={{ color: "#212529", fontSize: "2rem", fontWeight: "bold" }}
    >
      LIST OF MACHINARIES
    </label>
  </div>

  {/* ============ BLACK PART ============ */}
  <div className="content-block">
    <div className="section-full content-inner video-section">
      <div className="container">
        <div className="section-content">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-10 col-md-12 align-self-center video-infobx">
              <div className="card shadow-sm border-0 mb-5">
                <div className="card-header bg-dark text-white fw-semibold fs-5">
                  BLACK PART
                </div>
                <div className="card-body p-0">
                  <div style={{ overflowX: "auto" }}>
                    <table className="table table-bordered table-striped mb-0" style={{ minWidth: "600px" }}>
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "80px" }}>No.</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jsonData.map((data, idx) => (
                          <tr key={idx}>
                            <td>{data.title}</td>
                            <td>{data.REMARKS}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* ============ WHITE PART ============ */}
  <div className="content-block">
    <div className="section-full content-inner video-section">
      <div className="container">
        <div className="section-content">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-10 col-md-12 align-self-center video-infobx">
              <div className="card shadow-sm border-0 mb-5">
                <div className="card-header bg-dark text-white fw-semibold fs-5">
                  WHITE PART
                </div>
                <div className="card-body p-0">
                  <div style={{ overflowX: "auto" }}>
                    <table className="table table-bordered table-striped mb-0" style={{ minWidth: "600px" }}>
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "80px" }}>No.</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jsonData2.map((data, idx) => (
                          <tr key={idx}>
                            <td>{data.title}</td>
                            <td>{data.REMARKS}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* ============ YELLOW PART ============ */}
  <div className="content-block">
    <div className="section-full content-inner video-section">
      <div className="container">
        <div className="section-content">
          <div className="row d-flex justify-content-center">
            <div className="col-lg-10 col-md-12 align-self-center video-infobx">
              <div className="card shadow-sm border-0 mb-5">
                <div className="card-header bg-dark text-white fw-semibold fs-5">
                  YELLOW PART
                </div>
                <div className="card-body p-0">
                  <div style={{ overflowX: "auto" }}>
                    <table className="table table-bordered table-striped mb-0" style={{ minWidth: "600px" }}>
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "80px" }}>No.</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jsonData3.map((data, idx) => (
                          <tr key={idx}>
                            <td>{data.title}</td>
                            <td>{data.REMARKS}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
        <Footer4 />
        <ScrollToTop className="icon-up" />
      </>
    );
  }
}

export default Lfc;
